export default __webpack_public_path__ + "media/images/paylogos/gray/electron-2a320da1a6f73d9f4e118af139ab48c5.png";